/**
 * Shared path checks for public portal routes (tenant, contractor, vendor, booking).
 * Used by AuthGate and AuthContext so unauthenticated portal URLs never fall through
 * to the internal agency login flow.
 */
export const isPublicPortalPath = (pathname = '') => {
  if (!pathname) return false;

  return (
    pathname.startsWith('/public/') ||
    pathname === '/contractor' ||
    pathname.startsWith('/contractor/') ||
    pathname === '/tenant' ||
    pathname.startsWith('/tenant/') ||
    pathname === '/vendor' ||
    pathname.startsWith('/vendor/') ||
    pathname.startsWith('/book/') ||
    pathname.startsWith('/calendar/')
  );
};
